import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { BaseControl, TypeChecker } from '../../../shared';
import { InputTextareaModule } from 'primeng/inputtextarea';

@Component({
  selector: 'app-textarea-control',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, InputTextareaModule ],
  template: `
      <div [formGroup]="formGroup" *ngIf="typeChecker.isTextArea(control)" class="w-full">
        <textarea pInputTextarea  [formControlName]="control.name"
          [rows]="control.rows"></textarea>
      </div>
  `,
  styles: `
    :host {
      display: contents;
    }
  ` 
})
export class InputTextareaControlComponent {
  @Input() control !: BaseControl<any>;
  @Input() formGroup !: FormGroup;

  typeChecker = TypeChecker;
}
